// The purpose of this object is use the new Account service call and associated models and create the structure that
// is produced by the legacy Account call. At some later date we may want to remove
// all the legacy structure dependencies and use just the new structure.
export var LegacyTermsAndConditionsAdaptor = function(termsAndConditionsData) {
    var termsAndConditions = {};

    // Constructor
    if (termsAndConditionsData) {
        // Map the old termsAndConditions structure of the legacy Account service to the new Account service call
        // termsAndConditions structure. Btw, the new termsAndConditions structure can be
        // obtained from the new TermsAndConditions models.
        termsAndConditions.version = termsAndConditionsData.version;
        termsAndConditions.acceptedDate = termsAndConditionsData.acceptedDate;
        termsAndConditions.valid = termsAndConditionsData.valid;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return termsAndConditions;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyTermsAndConditionsAdaptor.js
// module id = 201
// module chunks = 0